export default __webpack_public_path__ + "static/desktop_1-f0544bde33b7df680ad71384f9426e87.webp";